import { ChevronDown } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const ADMIN_GROUPS = [
  { key: "setup", label: "Club setup", tabs: [
    ["venues", "Venues & Pitches"], ["/app/teams", "Teams"], ["seasons", "Seasons"], ["leagues", "Leagues"], ["referees", "Referees"], ["settings", "Settings"], ["features", "Features"], ["public-api", "Public API"],
  ] },
  { key: "bookings", label: "Bookings", tabs: [
    ["bookings", "Bookings"], ["utilization", "Utilisation"], ["payments", "Payments"], ["fa-import", "FA Import"], ["upload", "Bulk upload"], ["league-export", "League Team Info"],
  ] },
  { key: "people", label: "People", tabs: [
    ["users", "Users"], ["roles", "Roles"], ["approval-routing", "Approval Routing"], ["waiting-list-emails", "Waiting List Emails"], ["access-requests", "Access Requests"], ["proposals", "Coach Proposals"], ["/app/players?view=queue", "Player Registrations"], ["committee", "Committee & Notices"], ["committee-contacts", "Committee Contacts"], ["secretary", "Secretary"],
  ] },
  { key: "welfare", label: "Welfare & safety", tabs: [
    ["incidents", "Incident Forms"],
    ["chat", "Chat Oversight"],
  ] },
  { key: "kit", label: "Kit & Equipment", tabs: [
    ["product-catalogue", "Product Catalogue"],
  ] },
  { key: "records", label: "Records", tabs: [
    ["audit", "Audit"], ["emails", "Emails"], ["inbox", "Club Inbox"], ["/app/reports", "Report Builder"], ["releases", "Release notes"], ["feedback", "App Improvement Requests"],
  ] },
];

export const ADMIN_TAB_LABELS = Object.fromEntries(ADMIN_GROUPS.flatMap(g => g.tabs));

export function AdminGroupNav({ tab, onChange }) {
  return (
    <div className="flex flex-wrap gap-2" data-testid="admin-group-nav">
      {ADMIN_GROUPS.map(g => {
        const active = g.tabs.some(([k]) => k === tab);
        return (
          <DropdownMenu key={g.key}>
            <DropdownMenuTrigger asChild>
              <button type="button" data-testid={`admin-group-${g.key}`}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-md text-[11px] tracking-widest uppercase border transition-colors ${active ? "border-[#83B68B]/60 bg-[#83B68B]/15 text-[#83B68B]" : "border-border hover:border-white/40"}`}>
                {g.label}{active && <span className="opacity-70 normal-case tracking-normal font-normal">· {ADMIN_TAB_LABELS[tab]}</span>}<ChevronDown className="w-3 h-3" />
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="start" className="min-w-[200px]">
              {g.tabs.map(([k, l]) => (
                <DropdownMenuItem key={k} onSelect={() => onChange(k)} data-testid={`admin-tab-${k}`} className={`cursor-pointer text-sm ${tab === k ? "text-[#83B68B]" : ""}`}>{l}</DropdownMenuItem>
              ))}
            </DropdownMenuContent>
          </DropdownMenu>
        );
      })}
    </div>
  );
}
